import axios from "axios";
import {getCookie} from "../utils/cookies";
import {getApiDomainName} from './common';

axios.defaults.baseURL = '/api';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

let http = axios.create()

// 请求拦截器
http.interceptors.request.use(
    config => {
        let token = getCookie('token');
        token && (config.headers.Authorization = "Bearer " + unescape(token));
        return config;
    },
    error => {
        return Promise.error(error);
    })

/**
 * get方法，对应get请求 *
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 **/
export function get(url, params) {
    return new Promise((resolve, reject) => {
        http.get(getApiDomainName() + url, {params: params}).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 **/
export function post(url, params) {
    return new Promise((resolve, reject) => {
        http.post(getApiDomainName() + url, params).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

/**
 * 上传文件
 * @param {String} url 链接
 * @param {Object} formdata FormData对象
 */
export function filepost(url, formdata) {
    let token = getCookie('token')
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": "Bearer " + unescape(token)
        }
    };
    return new Promise((resolve, reject) => {
        axios.create({withCredentials: true}).post(getApiDomainName() + url, formdata, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
